import React from 'react';
import moment from 'moment';
import { useTranslation } from 'common/i18n/hooks';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { ExperimentCollectionType } from 'apps/experiments/src/types';
import { ButtonReact } from 'common/components/button';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { useExperimentPageContext } from 'apps/experiments/src/components/context';
import { TrackingEventSource } from 'apps/experiments/src/components/tracking';
import { useDraftExperiment } from 'iron/apps/experiments/src/components/hooks/draft-experiment';
import styles from './index.module.styl';
import { ExperimentPageConfigurationSetting } from './_setting';
export function ExperimentPageConfiguration() {
  var _experimentState$sett, _exposureEventSetting;
  const i18n = useTranslation();
  const experimentState = useExperimentsStore(state => state.experimentState);
  const {
    newDraftFromCurrentState
  } = useDraftExperiment();
  const {
    canEdit
  } = useExperimentPageContext();
  const percentFormatter = new Intl.NumberFormat(i18n.language, {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
  const {
    collectionMethod,
    exposureEventSettings,
    confidenceLevel,
    controlKey
  } = (_experimentState$sett = experimentState === null || experimentState === void 0 ? void 0 : experimentState.settings) !== null && _experimentState$sett !== void 0 ? _experimentState$sett : {};
  const {
    start_date: startDate,
    end_date: endDate
  } = experimentState !== null && experimentState !== void 0 ? experimentState : {};
  const editSettingsTooltip = canEdit ? undefined : {
    text: i18n.t("experiments.actions.no-edit-access")
  };
  return <aside className={styles.configuration} data-sentry-component="ExperimentPageConfiguration" data-sentry-source-file="index.tsx">
      {experimentState && <>
          <div className={styles.settings}>
            <ExperimentPageConfigurationSetting label={i18n.t("experiments.configuration.status")} value={i18n.t("experiments.status.".concat(experimentState.status))} />
            <ExperimentPageConfigurationSetting label={i18n.t("experiments.configuration.start-date")} value={startDate ? moment(startDate).format("LL") : i18n.t("experiments.configuration.not-set")} disabled={!startDate} />
            <ExperimentPageConfigurationSetting label={i18n.t("experiments.configuration.end-date")} value={endDate ? moment(endDate).format("LL") : i18n.t("experiments.configuration.not-set")} disabled={!endDate} />
            <ExperimentPageConfigurationSetting label={i18n.t("experiments.configuration.confidence")} value={confidenceLevel ? percentFormatter.format(confidenceLevel) : i18n.t("experiments.configuration.not-set")} disabled={!confidenceLevel} />
            {collectionMethod === ExperimentCollectionType.EXPOSURE_EVENTS && <ExperimentPageConfigurationSetting label={i18n.t("experiments.configuration.exposure-event")} value={(_exposureEventSetting = exposureEventSettings === null || exposureEventSettings === void 0 ? void 0 : exposureEventSettings.experimentName) !== null && _exposureEventSetting !== void 0 ? _exposureEventSetting : ""} />}
            <ExperimentPageConfigurationSetting label={i18n.t("experiments.configuration.control-key")} value={controlKey ? controlKey : i18n.t("experiments.configuration.not-set")} disabled={!controlKey} />
          </div>
          <ButtonReact size={ButtonSize.Medium} theme={ButtonTheme.Secondary} disabled={!canEdit} tooltip={editSettingsTooltip} onClick={() => newDraftFromCurrentState(TrackingEventSource.ExperimentPageConfiguration)}>
            {i18n.t("experiments.configuration.edit-settings")}
          </ButtonReact>
        </>}
    </aside>;
}